
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wachtwoord-vergeten",
      function () {
        return require("private-next-pages/wachtwoord-vergeten/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wachtwoord-vergeten"])
      });
    }
  